import { useAtomValue } from 'jotai';

import { DealType } from '../../../gql/generated/graphql';
import { DealStateEnum } from '../../../utils/types/deal';
import { devDealStateAtom, devDealTypeAtom, isDevActiveAtom } from '../components/devToolbarAtoms';
import { UserDeal } from '../utils';

type EffectiveDealFields = {
  type: DealType | null | undefined;
  state: string | null | undefined;
  requestBoot: boolean;
  cameFromMarketplace: boolean;
  isHandedBack: boolean;
};

const useEffectiveDealFields = (userDeal: UserDeal): EffectiveDealFields => {
  const isDevActive = useAtomValue(isDevActiveAtom);
  const devDealType = useAtomValue(devDealTypeAtom);
  const devDealState = useAtomValue(devDealStateAtom);

  const type = isDevActive ? devDealType : userDeal?.type;
  const state = isDevActive ? devDealState : userDeal?.state;
  const cameFromMarketplace = userDeal?.came_from_marketplace === true;

  return {
    type,
    state,
    requestBoot: !isDevActive && !!userDeal?.request_boot,
    cameFromMarketplace,
    isHandedBack:
      cameFromMarketplace &&
      type !== DealType.Marketplace &&
      state === DealStateEnum.SoftClose &&
      userDeal?.setter_id == null,
  };
};

export default useEffectiveDealFields;
